import Image from "next/image";
import React from "react";

import styles from "./Header.module.scss";

const Header = () => {
  return (
    <div className={styles.header}>
      <div className={styles.logo}>
        <Image
          src="/images/landing_page_pipfarm/logo.png"
          alt="PipFarm Logo"
          width={200}
          height={47.16}
        />
      </div>
      <div className={styles.interviewTitle}>
        <h1 className={styles.title}>Phỏng vấn</h1>
        <div className={styles.titleImage}>
          <Image
            src="/images/landing_page_pipfarm/CEO.png"
            alt="CEO PipFarm"
            width={672}
            height={71}
          />
        </div>
      </div>
      <div className={styles.ceos}>
        <div className={`${styles.ceo} ${styles.leftCeo}`}>
          <Image
            src="/images/landing_page_pipfarm/Frame.png"
            alt="James Clyde"
            layout="fill"
            className={styles.profileImage}
          />
        </div>
        <div className={styles.centerImage}>
          <Image
            src="/images/landing_page_pipfarm/image2.png"
            alt="Center Image"
            width={998}
            height={449}
            className={styles.profileImage}
          />
        </div>
        <div className={`${styles.ceo} ${styles.rightCeo}`}>
          <Image
            src="/images/landing_page_pipfarm/Minh Tuan.png"
            alt="Nguyễn Minh Tuấn"
            layout="fill"
            className={styles.profileImage}
          />
        </div>
      </div>

      <div className={styles.elipseIconLeft}>
        <Image
          src="/images/landing_page_pipfarm/Ellipse1.png"
          alt="Left Ellipse"
          className={styles.elipseIconLeft}
          width={521}
          height={521}
        />
      </div>
      <div className={styles.elipseIconRight}>
        <Image
          src="/images/landing_page_pipfarm/Ellipse1.png"
          alt="Right Ellipse"
          width={521}
          height={521}
        />
      </div>
    </div>
  );
};

export default Header;
